"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject13ToJSON = exports.InlineObject13FromJSONTyped = exports.InlineObject13FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineObject13FromJSON(json) {
    return InlineObject13FromJSONTyped(json, false);
}
exports.InlineObject13FromJSON = InlineObject13FromJSON;
function InlineObject13FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'parent': !(0, runtime_1.exists)(json, 'parent') ? undefined : json['parent'],
        'sortOrder': !(0, runtime_1.exists)(json, 'sortOrder') ? undefined : json['sortOrder'],
        'isEnabled': !(0, runtime_1.exists)(json, 'isEnabled') ? undefined : json['isEnabled'],
    };
}
exports.InlineObject13FromJSONTyped = InlineObject13FromJSONTyped;
function InlineObject13ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'parent': value.parent,
        'sortOrder': value.sortOrder,
        'isEnabled': value.isEnabled,
    };
}
exports.InlineObject13ToJSON = InlineObject13ToJSON;
